import React from "react"
import Expandable from "profiles/components/Expandable"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import * as sharedSelectors from "shared/profiles/political-committee/political-committee-selectors"
import { cleanUpHtml } from "shared/imports/sharedHelperFunctions"
import paths from "shared/imports/sharedPaths"

import { segueToProfileWithId, segueToUrl } from "global-action-creators"
import { Button, DTVCard, DTVGrid } from "quorumdesign"

const affiliatedCommitteeMapStateToProps = (state, props) => ({
    committees: sharedSelectors.selectAffiliatedCommittees(state, props),
    profileId: sharedSelectors.selectId(state, props),
    route: paths.affiliated_committees,
})

const jointFundraisingCommitteeMapStateToProps = (state, props) => ({
    committees: sharedSelectors.selectJointFundraisingCommittees(state, props),
    profileId: sharedSelectors.selectId(state, props),
    route: paths.joint_fundraiser_participants,
})

const jointFundraisingRepresentativeMapStateToProps = (state, props) => ({
    committees: sharedSelectors.selectJointFundraisingRepresentatives(state, props),
    profileId: sharedSelectors.selectId(state, props),
    route: paths.joint_fundraiser_representatives,
})

/**
 * The CommitteeGrid displays Political Committee DTVCards for the Political Commitee Profile.
 * PoliticalCommitteeAffiliatedCommitteeGrid will display all affiliated committees associated with the profile committee.
 * PoliticalCommitteeJointFundraiserCommitteeGrid will display committees that are currently participating with the profile committee if it is a JFR.
 */
export class CommitteeGrid extends Expandable {
    renderCommitteesList(committees) {
        return committees.map((committee) => (
            <DTVCard
                icon="dollar-sign"
                onClick={() => this.props.segueToUrl(`/political_committee/${committee.id}`)}
                text={
                    committee.committee_type &&
                    DjangIO.app.pac.types.PoliticalCommitteeType.by_value(committee.committee_type).label
                }
                textType="primary"
                title={committee.name}
            />
        ))
    }

    render() {
        if (this.props.committees && this.props.committees.length) {
            return (
                <DTVGrid
                    collapsible
                    collapsedGridRows={2}
                    gridWidth={2}
                    headerText={this.props.title}
                    headerButtons={[
                        <Button
                            text="View in Search"
                            leftIcon="search"
                            type="secondary"
                            onClick={() =>
                                this.props.segueToProfileWithId(
                                    this.props.profileId,
                                    DjangIO.app.models.QuorumDataType.political_committee.value,
                                    this.props.route,
                                )
                            }
                        />,
                    ]}
                >
                    {this.renderCommitteesList(this.props.committees)}
                </DTVGrid>
            )
        } else {
            return null
        }
    }
}

export const PoliticalCommitteeAffiliatedCommitteeGrid = connect(affiliatedCommitteeMapStateToProps, {
    segueToProfileWithId,
    segueToUrl,
})(CommitteeGrid)
export const PoliticalCommitteeJointFundraiserCommitteeGrid = connect(jointFundraisingCommitteeMapStateToProps, {
    segueToProfileWithId,
    segueToUrl,
})(CommitteeGrid)
export const PoliticalCommitteeJointFundraiserRepresentativeGrid = connect(
    jointFundraisingRepresentativeMapStateToProps,
    { segueToProfileWithId, segueToUrl },
)(CommitteeGrid)
